import {GraphicType} from '@mintdata/mint-kit/api/assets/Graphic';
import {ColorWithVisibility} from '@mintdata/mint-kit/api/models/ColorWithVisibility';
import {css} from 'glamor';

export abstract class ImageUtil
{
    public static getGraphicClassName(type:GraphicType,
                                      color1:ColorWithVisibility,
                                      color2:ColorWithVisibility):string
    {
        switch( type )
        {
            case GraphicType.Illustration1:
                return css({
                    '& [fill="#68e1fd"]': {
                        fill: color1.toCssString()
                    }
                }).toString();

            case GraphicType.Illustration2:
            {
                if( !color1.visibility.value && color2.visibility.value )
                    color1 = color2;
                else if( !color2.visibility.value && color1.visibility.value )
                    color2 = color1;

                return css({
                    '& [fill="#6c63ff"]': {
                        fill: color1.toCssString()
                    },
                    '& [stroke="#6c63ff"]': {
                        stroke: color1.toCssString()
                    },
                    '& [fill="#3f3d56"]': {
                        fill: color2.toCssString()
                    },
                    '& [stroke="#3f3d56"]': {
                        stroke: color2.toCssString()
                    }
                }).toString();
            }
        }

        return '';
    }
}
